import { useAllUnits } from "http-hooks/unit/useUnit";
import DeleteUnit from "components/unit/DeleteUnit";
import { useState } from "react";
import useModalStore from "store/modals";
import InputSearch from "components/ui/InputSearch";
import Select from "components/ui/Select";
import MasterPage, {
  FilterRow,
  FilterCell,
  ClearFiltersButton,
  AddButton,
  StatusIcon,
  EditAction,
  DeleteAction,
} from "components/ui/MasterPage";

const systemOptions = [
  { value: "", label: "All" },
  { value: "1", label: "Yes" },
  { value: "0", label: "No" },
];

const initialFilter = {
  unitname: "",
  systemg: "",
  page: 1,
  limit: 10,
};

const columns = [
  { key: "unitname", header: "Unit Name" },
  {
    key: "parentUnit",
    header: "Unit Under",
    render: (unit) => unit.parentUnit?.unitname || "-",
  },
  {
    key: "systemg",
    header: "System Generated",
    render: (unit) => <StatusIcon value={unit.systemg} />,
  },
  { key: "actions", header: "Action", isActions: true },
];

export default function UnitMaster() {
  const [selectedSystemG, setSelectedSystemG] = useState(null);
  const [filter, setFilter] = useState(initialFilter);
  const { openModal } = useModalStore();

  const openSetModal = (id) => openModal("unit", id);

  const handleUnitNameSearch = (searchTerm) => {
    setFilter((prev) => ({ ...prev, unitname: searchTerm, page: 1 }));
  };

  const handleSystemGChange = (selectedOption) => {
    setSelectedSystemG(selectedOption);
    setFilter((prev) => ({
      ...prev,
      systemg: selectedOption?.value || "",
      page: 1,
    }));
  };

  const clearFilters = () => {
    setSelectedSystemG(null);
    setFilter(initialFilter);
  };

  const {
    isLoading,
    data: { data: allunits, page: currentPage, totalPages } = [],
  } = useAllUnits(filter);

  return (
    <MasterPage
      title="Unit Master"
      headerActions={
        <AddButton onClick={() => openSetModal()}>Add unit</AddButton>
      }
      filters={
        <FilterRow>
          <FilterCell>
            <InputSearch
              onSearch={handleUnitNameSearch}
              label="Unit Name"
              placeholder="Search Unit Name"
            />
          </FilterCell>
          <FilterCell>
            <Select
              value={selectedSystemG}
              onChange={handleSystemGChange}
              options={systemOptions}
              label="System Generated"
              placeholder="All"
            />
          </FilterCell>
          <ClearFiltersButton onClick={clearFilters} />
        </FilterRow>
      }
      columns={columns}
      data={allunits}
      isLoading={isLoading}
      rowKey="unitId"
      deleteComponent={DeleteUnit}
      renderActions={(unit, setDeleteItemId) =>
        unit.systemg === 0 ? (
          <div className="flex gap-2">
            <EditAction
              onClick={() => openSetModal(unit.unitId)}
              title="Edit Unit"
            />
            <DeleteAction
              onClick={() => setDeleteItemId(unit.unitId)}
              title="Delete Unit"
            />
          </div>
        ) : (
          <span className="text-gray-400">Not editable</span>
        )
      }
      pagination={{
        currentPage,
        totalPages,
        onPageChange: (page) => setFilter((prev) => ({ ...prev, page })),
      }}
    />
  );
}
